import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/qrcode.png'


const _withScopeId = n => (_pushScopeId("data-v-9edc5310"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "page-wrap" }
const _hoisted_3 = { class: "section-wrap" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "contact-wrap" }
const _hoisted_6 = { class: "contact" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "业务咨询：18807180682", -1))
const _hoisted_8 = { class: "contact" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "业务咨询：18807180682", -1))
const _hoisted_10 = { class: "contact" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "投诉电话：17798230180", -1))
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"info-text\" data-v-9edc5310><a href=\"/help/about\" data-v-9edc5310>关于我们</a><a href=\"/help/contact\" data-v-9edc5310>联系我们</a><a href=\"/help/bd\" data-v-9edc5310>项目推广</a><a href=\"/help/join\" data-v-9edc5310>企业入驻</a><a href=\"/help/service\" data-v-9edc5310>服务申明</a><a href=\"/help/complain\" data-v-9edc5310>投诉删除</a><a href=\"/help/ugc\" data-v-9edc5310>文章发布</a><a href=\"/ucenter/help\" data-v-9edc5310>会员服务</a><a href=\"/project\" data-v-9edc5310>项目招商</a></div><div class=\"tips\" data-v-9edc5310> 地平线跳动友情提示：多打电话、多咨询、实地考察，可降低投资风险 </div><div data-v-9edc5310><div data-v-9edc5310> Copyright Hubei Horizon Jumping Technology Co., Ltd 湖北地平线跳动科技有限公司 版权所有 </div><a href=\"https://beian.miit.gov.cn/\" target=\"_blank\" class=\"beian\" data-v-9edc5310>鄂ICP备2022008172号</a></div>", 3)
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"wx\" data-v-9edc5310><div class=\"item app-wx\" data-v-9edc5310><img src=\"" + _imports_0 + "\" data-v-9edc5310><span data-v-9edc5310>地平线跳动<br data-v-9edc5310>微信小程序</span></div><div class=\"item app-dy\" data-v-9edc5310><img src=\"" + _imports_0 + "\" data-v-9edc5310><span data-v-9edc5310>地平线跳动<br data-v-9edc5310>抖音小程序</span></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_svg_icon, { icon: "icon_phone" }),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_svg_icon, { icon: "icon_phone" }),
              _hoisted_9
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_svg_icon, { icon: "icon_phone" }),
              _hoisted_11
            ])
          ]),
          _hoisted_12
        ]),
        _hoisted_15
      ])
    ])
  ]))
}